function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import * as React from "react";
import styled from "styled-components";
import { space, color } from "styled-system";
var Svg = styled("svg")({
  flex: "none"
}, space, color);
var SvgSlr = React.forwardRef(function (props, ref) {
  return React.createElement(Svg, _extends({}, props, {
    viewBox: "0 0 24 24",
    fill: "currentcolor",
    height: props.size,
    width: props.size,
    ref: ref
  }), React.createElement("path", {
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12z",
    fill: "inherit"
  }), React.createElement("path", {
    d: "M8.94 16.5c.088.273 1.175 1.398 2.305 1.398 1.675 0 2.654-1.011 2.654-2.473 0-1.355-.678-2.129-2.391-2.882-2.07-.838-3.351-2.065-3.351-4.108 0-2.257 1.638-3.935 4.104-3.935 1.299 0 2.615.817 3.052 1.364l-1.048 1.09c-.414-.257-.911-.906-2.06-.906-1.732 0-2.391 1.183-2.391 2.172 0 1.355.772 2.022 2.522 2.796 2.146.947 3.239 2.13 3.239 4.258 0 2.237-1.458 4.226-4.452 4.226-1.224 0-2.531-.817-3.317-1.818L8.941 16.5zm1.397-7.727c-.261-.546-.087-1.09-.087-1.09 6.633-1.092 5.412 5.362 5.412 5.362-.524-1-1.048-1.181-1.048-1.181.087-3.728-4.277-3.091-4.277-3.091zm2.968 5.909c.263.637-.04 1.299-.04 1.299-7.553.973-5.513-5.932-5.515-5.932.4 1.06.898 1.308.898 1.308-.142 4.325 4.657 3.325 4.657 3.325z",
    fill: "white"
  }));
});
SvgSlr.displayName = "SvgSlr";
SvgSlr.defaultProps = {
  size: 24,
  color: "#FDA616"
};
export default SvgSlr;